import React, { useEffect, useMemo, useState } from 'react';
import { api } from '../../api.js';
import PageHeader from '../../components/PageHeader.jsx';
import { Icon, SECTION_COLOR } from '../../icons.jsx';
import OwnerOperatorFormModal from './OwnerOperatorFormModal.jsx';
import { displayPhone } from '../../phone.js';

const TrashIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>;

export default function OwnerOperatorList() {
  const [rows, setRows] = useState(null);
  const [query, setQuery] = useState('');
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  function load() {
    setRows(null);
    api('/dispatch/owner-operators').then(setRows).catch(() => setRows([]));
  }

  const deleteRow = async (e, r) => {
    e.stopPropagation();
    if (!window.confirm(`Delete "${r.name}"? This can't be undone.`)) return;
    await api(`/dispatch/owner-operators/${r.id}`, { method: 'DELETE' });
    load();
  };

  useEffect(() => { load(); }, []);

  const filtered = useMemo(() => {
    if (!rows) return [];
    const q = query.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter(r => [r.name, r.ref_number, r.mc_number, r.dot_number, r.phone].filter(Boolean).some(v => v.toLowerCase().includes(q)));
  }, [rows, query]);

  return (
    <div>
      <PageHeader
        icon={Icon.control}
        title="Owner Operators"
        subtitle="Independent contractors who own their own truck — own or leased authority, settlement-based pay"
        color={SECTION_COLOR.control}
        actions={<button className="primary-btn" onClick={() => { setEditing(null); setFormOpen(true); }}>+ New owner operator</button>}
      />

      <div className="panel filter-row-panel">
        <div className="filter-row">
          <input placeholder="Type to filter..." value={query} onChange={e => setQuery(e.target.value)} style={{ width: 240 }} />
        </div>
      </div>

      {rows === null && <div className="empty">Loading...</div>}
      {rows && rows.length === 0 && <div className="empty">No owner operators yet — click "+ New owner operator" above.</div>}

      {rows && rows.length > 0 && (
        <table>
          <thead>
            <tr><th>Ref#</th><th>Name</th><th>Phone</th><th>Authority</th><th>MC#</th><th>DOT#</th><th>Pay</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {filtered.map(r => (
              <tr key={r.id} onClick={() => { setEditing(r); setFormOpen(true); }} style={{ cursor: 'pointer' }}>
                <td>{r.ref_number || '—'}</td>
                <td>{r.name}</td>
                <td>{displayPhone(r.phone) || '—'}</td>
                <td>{r.authority_type}</td>
                <td>{r.mc_number || '—'}</td>
                <td>{r.dot_number || '—'}</td>
                <td>{r.pay_type ? `${r.pay_value ?? ''} ${r.pay_type}`.trim() : '—'}</td>
                <td>{r.status || 'Active'}</td>
                <td>
                  <button type="button" title="Delete" onClick={e => deleteRow(e, r)}
                    style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30, border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--red)', cursor: 'pointer', padding: 0 }}>
                    <TrashIcon />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {formOpen && (
        <OwnerOperatorFormModal ownerOperator={editing} onClose={() => setFormOpen(false)} onSaved={() => { setFormOpen(false); load(); }} />
      )}
    </div>
  );
}
